import { render, staticRenderFns } from "./LeaderboardManualPointPopup.vue?vue&type=template&id=2fea8cac&scoped=true"
import script from "./LeaderboardManualPointPopup.vue?vue&type=script&lang=js"
export * from "./LeaderboardManualPointPopup.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardManualPointPopup.vue?vue&type=style&index=0&id=2fea8cac&prod&lang=scss&scoped=true"
import style1 from "./LeaderboardManualPointPopup.vue?vue&type=style&index=1&id=2fea8cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea8cac",
  null
  
)

export default component.exports